import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { filterPurchaseOrder } from "../../../Helpers/apiCalls/Purchases/purchaseOrderApi";
import { dateFormat } from "../../../Helpers/Utils/Common";
import { filterInvoice } from "../../../Helpers/apiCalls/Purchases/purchaseInvoiceApi";


export default function PurchaseOrderPicker(props) {

  const [poID, setPoID] = useState("");
  const [purchaseInvoice, setPurchaseInvoice] = useState([]);

  async function fetchAllPurchaseInvoice() {
    const response = await filterInvoice ({payment_status: "open"});
    if (response.data) {
      const res = response.data.data.map((row) => {
        var info = row;
        info.value = row.id;
        info.label = row.invoice_label;
        return info;
      })
      setPurchaseInvoice(res)
    }
  }

  useEffect(() => {
    fetchAllPurchaseInvoice();
  }, []);

  return (
    <div>
      <Modal show={props.show} onHide={props.hide} size="lg" centered>
        <Modal.Body>
          <span className="PI-modal-header">{props.header}</span>
          <div className="PI-modal-body mt-3">
            <span className="PI-modal-label">PURCHASE INVOICE NO.</span>
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder="Select Purchase Order..."
              value={purchaseInvoice.filter((info) => info.value === poID)[0]}
              options={purchaseInvoice}
              onChange={(e) => setPoID(e.value)}
            />
          </div>
          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              onClick={props.hide}
              className="button-secondary me-3"
            >
                Close
            </button>
            <button
              type="button"
              onClick={() => props.proceed(poID)}
              className="button-primary"
              disabled={!poID||poID===""}
            >
              Continue
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
